import Accordions from "a11y-accordion-component";
import tippy from "tippy.js";
import { breakpoints, classes } from "../../variables.json";
import { debounce } from "../utils/debounce";

window.addEventListener("resize", debounce(onResizeHandler));
onResizeHandler();

function onResizeHandler() {
  const mediaQuery = window.matchMedia(`(min-width: ${breakpoints.content})`);

  try {
    if (mediaQuery.matches) {
      Accordions.destroy("submenu-list");
    } else {
      Accordions.render("submenu-list", {
        isMultiSelectable: false,
        isCollapsible: true
      });
    }
  } catch (e) {
    // noop
  }
}

tippy("[data-submenu-toggle]", {
  theme: "submenu",
  trigger: "click",
  appendTo: "parent",
  placement: "bottom",
  maxWidth: "100%",
  animation: "fade",
  interactive: true,
	offset: [0, 0],
	allowHTML: true,
  popperOptions: {
    modifiers: [{
			// run it before `applyStyle` modifier
			name: 'overrideStylesSubmenu',
			enabled: true,
			phase: "beforeWrite",
			requires: ["computeStyles"],
			fn({ state }) {
				if (!window.matchMedia(`(min-width:${breakpoints.medium})`).matches) {
					state.styles.popper.top = "100%";
					state.styles.popper.left = 0;
					state.styles.popper.right = 0;
					state.styles.popper.width = "100%";
					state.styles.popper.maxWidth = "100%";
					state.styles.popper.transform = "";
				} else {
					state.styles.popper.top = "5px";
					state.styles.popper.left = "60px";
					state.styles.popper.width = "100%";
					state.styles.popper.maxWidth = "225px";
				}
			},
			effect: ({ state }) => {
				if (!window.matchMedia(`(min-width:${breakpoints.medium})`).matches) {
					state.elements.popper.style.top = "100%";
					state.elements.popper.style.left = 0;
					state.elements.popper.style.right = 0;
					state.elements.popper.style.width = "100%";
					state.elements.popper.style.maxWidth = "100%";
					state.elements.popper.style.transform = "";
				} else {
					state.elements.popper.style.top = "5px";
					state.elements.popper.style.left = "60px";
					state.elements.popper.style.width = "100%";
					state.elements.popper.style.maxWidth = "225px";
				}
			}
    }]
  },
  content(reference) {
    const id = reference.getAttribute("data-submenu-toggle");
    const items = document.querySelectorAll(`[data-submenu-item="${id}"]`);

    let html = "";
    [...items].forEach(node => {
      html += node.outerHTML;
    });

    const regex = new RegExp(`data-submenu-item="${id}"`, "g");
    return html.replace(regex, "");
  },
  onShow() {
    document.documentElement.classList.add(classes["body-fade"]);
  },
  onHide({ reference }) {
    document.documentElement.classList.remove(classes["body-fade"]);
  }
});
